<button
    class="import-button"
    mat-icon-button
    matTooltipShowDelay="500"
    matTooltip="{{'Import' | translate}}"
    matTooltipClass="mat-tooltip-cp"
    (click)="invokeImportMethod($event)"
>
    <mat-icon>arrow_downward</mat-icon>
</button>
